import {useSelector} from "react-redux";

const PassiveLogin = () => {
    const passiveLogin = useSelector((state) => state.passiveLogin);
    const baseCommunity = useSelector((state) => state.baseCommunity);
    return passiveLogin && (
        <iframe
            title="Scored Passive Login iframe"
            id="passiveLogin"
            name="passive_login"
            src={`https://authentication.win/session?passive=true&site=${encodeURIComponent(baseCommunity)}`}
            style={{display: 'none'}}
        />
    );
};

export default PassiveLogin;
